import formSubmit from '@/util/form_submit'

export default {
  bookmarksAll () {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: 'GET',
        url: '/merkliste.json',
        contentType: 'application/json',
        success: (data) => resolve(data),
        error: (data) => reject(data)
      })
    })
  },

  bookmarksAdd (jobId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: 'PUT',
        url: `/merkliste/${jobId}.json`,
        contentType: 'application/json',
        success: (data) => resolve(data),
        error: (data) => reject(data)
      })
    })
  },

  bookmarksRemove (jobId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: 'DELETE',
        url: `/merkliste/${jobId}.json`,
        contentType: 'application/json',
        success: (data) => resolve(data),
        error: (data) => reject(data)
      })
    })
  },

  saveSearch (apiUrl, searchProfile) {
    const body = {
      category_tags: searchProfile.tagKeys,
      custom_tags: searchProfile.customTags.join(',')
    }

    return new Promise((resolve) => {
      $.ajax({
        method: 'POST',
        url: apiUrl,
        data: JSON.stringify(body),
        contentType: 'application/json'
      }).done((data) => {
        resolve(data)
      })
    })
  },

  postSaveSearch (apiUrl, searchProfile) {
    const values = [
      ...searchProfile.tagKeys.map(key => ({ name: 'category_tags[]', value: key })),
      { name: 'custom_tags', value: searchProfile.customTags.join(',') }
    ]

    formSubmit(apiUrl, 'POST', values)
  },

  jobApplicationFetchUrls (jobApplication) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/jobs/applications/fetch_urls',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ job_application: jobApplication }),
        success: (data) => resolve(data),
        error: (data) => reject(data)
      })
    })
  },

  jobApplicationSend (jobApplication) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/jobs/applications',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ job_application: jobApplication }),
        success: (data) => resolve(data),
        error: (data) => reject(data)
      })
    })
  },
  resultsLoad (searchProfile, sort, page = 1) {
    const body = {
      category_tags: searchProfile.tagKeys,
      q: searchProfile.customTags.join(','),
      sort: sort,
      variant: 'fused',
      page
    }

    return new Promise((resolve) => {
      $.ajax({
        method: 'POST',
        url: '/stellenanzeigen.json',
        data: JSON.stringify(body),
        contentType: 'application/json'
      }).done((data) => {
        resolve(data)
      })
    })
  },

  jobLoad (jobId) {
    return new Promise((resolve) => {
      $.ajax({
        method: 'GET',
        url: `/jobs/${jobId}.json`,
        data: { variant: 'fused' },
        contentType: 'application/json'
      }).done((data) => {
        resolve(data)
      })
    })
  }
}
